import "./App.css";
import PageShell from "./AMain/PageShell";
import { BrowserRouter as Router, Routes, Route, useNavigate } from "react-router-dom";

import Savers from "./Page3Savers/Savers";
import ContactPage from "./Comms/ContactPage";
import DependentClassifier from "./Tools/DependentClassifier";
import GildarcLearnLanding from "./TryAgain/GildarcLearnLanding";
import RothEducationHelper from "./Jordan/RothEducationHelper";
import EligibilityFilter from "./Tools/EligibilityFilter";
import ModulesOverview from "./TryAgain/ModulesOverview";
import TaxFlowExplainerPage from "./TryAgain/TaxFlowExplainerPage";
import GildarcLearnHome from "./TryAgain/GildarcLearnHome";

import PrivacyPolicy from "./components/PrivacyPolicy";
import LegalNotice from "./components/LegalNotice";
import TermsOfUse from "./components/TermsOfUse";

import LoginPage from "./Login/LoginPage";
import LoginComplete from "./Login/LoginComplete";
import { AuthProvider } from "./Login/AuthContext";

function AppContent() {
  const navigate = useNavigate(); // ok to keep if you use it later

  return (
    <Routes>
      <Route path="/privacy" element={<PrivacyPolicy />} />
      <Route path="/saver" element={<Savers />} />
      <Route path="/contact" element={<ContactPage />} />

      <Route path="/tools" element={<PageShell />} />
      <Route path="/modules" element={<GildarcLearnLanding />} />
      <Route path="/hook" element={<GildarcLearnHome />} />
      <Route path="/tool-Roth" element={<RothEducationHelper />} />
      <Route path="/tool-Credit" element={<EligibilityFilter />} />
      <Route path="/start" element={<ModulesOverview />} />
      <Route path="/" element={<PageShell />} />
      <Route path="/terms" element={<TermsOfUse />} />
      <Route path="/legal" element={<LegalNotice />} />
      <Route path="/tool-Dependent" element={<DependentClassifier />} />
      <Route path="/Explain1040" element={<TaxFlowExplainerPage />} />

      <Route path="/login" element={<LoginPage />} />
      <Route path="/login-complete" element={<LoginComplete />} />
    </Routes>
  );
}

function App() {
  return (
    <Router>
      <AuthProvider>
        <div className="App">
          <header style={{ padding: "8px", textAlign: "right" }}></header>
          <AppContent />
        </div>
      </AuthProvider>
    </Router>
  );
}

export default App;
